export var getStatusBackgroundColor = function getStatusBackgroundColor(_ref, type) {
  var palette = _ref.palette;
  return {
    info: palette.primary["default"],
    success: palette.success["default"],
    error: palette.failure["default"],
    warning: palette.warning["default"]
  }[type];
};